const IntersectionObserverAnimations = () => {

	let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(/*entry.intersectionRatio !== 0*/entry.isIntersecting) {
					entry.target.classList.add('in-view');
					observer.unobserve(entry.target);
				}
			});
		},
{rootMargin: "0px 0px 0px 0px"});


	// The elements
	const domElToObserve = [
		'.io-animation',
		'.single-clinic .employee',
		'.acf-block-hero .content-area',
		'.wp-block-media-text__content',
	];

	// Set small timeout so the dom elements have time to get to their starting position before coming into .in-view position
	setTimeout(() => {
		document.querySelectorAll(domElToObserve.join(',')).forEach(el => { observer.observe(el) });
	}, 10);

	/**
	 * const domElToObserve = [
		'.io-animation',

		'.single-clinic .the-content .accordions-details',
		'.single-clinic .employees',
		'.single-clinic .employee',

		'.the-content > h1',
		'.the-content > h2',
		'.the-content > h3',
		'.the-content > h4',
		'.the-content > h5',
		'.the-content > h6',
		'.the-content > p',
		'.the-content > ul',
		'.the-content > ol',
		'.the-content > address',
		'.the-content > .wp-block-buttons',

		'.acf-block-hero .content-area',
		'.acf-block-hero figcaption',
		'.acf-block:not(.acf-block-hero):not(.acf-block-treatment-timeline):not(.acf-block-trustpilot-banner)',
		'.acf-block-treatment-types .treatment-type',
		'.acf-block-shop .product figure',

		'.wp-block-media-text__content',
		'.footer-reusable-block-1',

		'.trustpilot-reviews .trustpilot-reviews-inner',
		'.trustpilot-reviews .recap',
		'#the-footer',
	]
	 */
};

export default IntersectionObserverAnimations;